import type { InterventionSchedulingIndicatorProps } from "./intervention-indicator-scheduling.type";

import { useTranslation } from "react-i18next";

import { IconIndicator } from "@/ui/icon-indicator";

import { useInterventionSchedulingIndicator } from "./intervention-indicator-scheduling.hook";

export const InterventionSchedulingIndicator = ({
  schedulingState,
  isBig,
  showLabel = false,
}: InterventionSchedulingIndicatorProps) => {
  const { t } = useTranslation();
  const { subTypes, tooltipFallback, noIndicator, primarySchedulingIssue } =
    useInterventionSchedulingIndicator(schedulingState);

  if (noIndicator) return null;

  return (
    <IconIndicator
      type="schedulingIssue"
      subTypes={subTypes}
      tooltipFallback={{ type: "", subTypes: tooltipFallback }}
      label={
        showLabel
          ? t(`indicator:schedulingIssueLabel.${primarySchedulingIssue}`)
          : undefined
      }
      isBig={isBig}
    />
  );
};
